import { useState } from "react";
import { NAME_MAX, cleanName } from "./who";

/** Asks who is holding this phone. `onDone` gets a clean, non-empty name. */
export function WhoCard({ was, onDone, onCancel }: { was?: string | null; onDone: (name: string) => void; onCancel?: () => void }) {
  const [name, setName] = useState(was ?? "");
  const clean = cleanName(name);
  return (
    <section className="ad-card ad-who">
      <h2>Who are you</h2>
      <p className="ad-note">Your first name. What you do from this phone is logged under it.</p>
      <form className="ad-stack" onSubmit={(e) => { e.preventDefault(); if (clean) onDone(clean); }}>
        <input value={name} maxLength={NAME_MAX} placeholder="Your name" aria-label="Your name" autoComplete="off"
          onChange={(e) => setName(e.target.value)} />
        <div className="ad-row">
          <button type="submit" className="btn accent ad-grow" disabled={!clean}>That is me</button>
          {onCancel && <button type="button" className="btn quiet" onClick={onCancel}>Cancel</button>}
        </div>
      </form>
    </section>
  );
}
